// Liste der Felder, die bei jedem Publikationstypen anzeigt werden.
import { PartRelationData, PubtypeGroupData, WorkField } from '../util/types';

export const genericFields: WorkField[] = [
  'title',
  'subtitle',
  'other_title',
  'title_supplement',
  'person',
  'person_other',
  'organisation',
  'organisation_other',
  'project',
  'project_other',
  'date',
  'publication_status',
  'url',
  'external_id',
  'language',
  'description',
  'subject',
  'keyword',
  'note',
  'format',
  'medium',
  'related_identifier',
  'license',
  'license_text',
  'date_changed',
  'date_created',
  'origin',
  'deskman',
  'orcid_sync',
  'hidden',
  'editorial_status',
  'belong_to_project',
  'belong_to_organisation',
  'funded',
  'article_processing_charge',
  'access_level',
  'license_management_status',
  'obligatory_delivery',
  'pubtype',
  'id',
];

// Zuordnung welcher PubtypeGroup welche Pubtypes und speziellen Felder zugehören
export const pubtypeGroupData: PubtypeGroupData = {
  'audio_video_object': {
    pubtypes: [
      'audio_video_document',
      'radio_tv',
    ],
    fields: [
      'is_part_of',
      'issued',
      'form_subject',
      'publisher',
      'edition',
      'event_end_date',
      'event_name',
      'event_numbering',
      'event_place',
      'event_start_date',
    ],
  },
  'integrating_resource': {
    pubtypes: [
      'blog',
      'website',
    ],
    fields: [
      'has_part',
      'place',
      'event_end_date',
      'event_name',
      'event_numbering',
      'event_place',
      'event_start_date',
    ],
  },
  'fragment': {
    pubtypes: [
      'chapter',
      'chapter_in_conference',
      'chapter_in_legal_commentary',
      'article_newspaper',
      'article_journal',
      'article_integrating_resource',
      'lexicon_article',
      'editorial',
      'article_overview',
      'review',
      'abstract',
    ],
    fields: [
      'is_part_of',
      'is_part_of_other',
      'issued',
      'form_subject',
      'version',
      'number_of_pages',
      'peer_reviewed',
    ],
  },
  'self_contained': {
    pubtypes: [
      'monograph',
      'collection',
      'edition',
      'conference',
      'legal_commentary',
      'special_issue',
      'report_collection',
    ],
    fields: [
      'is_part_of',
      'issued',
      'has_part',
      'version',
      'form_subject',
      'publisher',
      'edition',
      'event_end_date',
      'event_name',
      'event_numbering',
      'event_place',
      'event_start_date',
      'number_of_pages',
    ],
  },
  'self_contained_or_fragment': {
    pubtypes: [
      'report_grey_literature',
      'interview',
      'lecture',
      'poster',
    ],
    fields: [
      'is_part_of',
      'issued',
      'form_subject',
      'version',
      'place',
      'edition',
      'number',
      'number_of_pages',
      'event_start_date',
      'event_end_date',
      'event_numbering',
      'event_name',
      'event_place',
    ],
  },
  'multi_volume_work': {
    pubtypes: [
      'multi_volume_work',
      'monograph_mvw',
      'collection_mvw',
      'edition_mvw',
      'conference_mvw',
    ],
    fields: [
      'is_part_of',
      'issued',
      'has_part',
      'form_subject',
      'publisher',
      'edition',
      'number_of_volumes',
      'number_of_pages',
      'event_end_date',
      'event_name',
      'event_numbering',
      'event_place',
      'event_start_date',
    ],
  },
  'series': {
    pubtypes: [
      'series',
    ],
    fields: [
      'title_abbreviation',
      'subseries_title',
      'has_part',
      'publisher',
    ],
  },
  'periodical': {
    pubtypes: [
      'newspaper',
      'journal',
    ],
    fields: [
      'title_abbreviation',
      'subseries_title',
      'has_part',
      'publisher',
    ],
  },
  'research_data_group': {
    pubtypes: [
      'research_data',
    ],
    fields: [
      'is_part_of',
      'issued',
      'resource_type',
      'publisher',
      'edition',
      'size',
      'dataversion',
      'geo_location',
      'event_end_date',
      'event_name',
      'event_numbering',
      'event_place',
      'event_start_date',
    ],
  },
  'patent': {
    pubtypes: [
      'patent',
    ],
    fields: [
      'patent_id',
      'publication_number',
      'priority_number',
      'priority_patent_application',
      'priority_country',
      'issued',
      'application_number',
      'application_country',
      'grant_number',
      'patent_family',
      'number_of_pages',
    ],
  },
  'thesis': {
    pubtypes: [
      'student_thesis',
      'dissertation',
      'habilitation',
    ],
    fields: [
      'is_part_of',
      'issued',
      'version',
      'form_subject',
      'publisher',
      'edition',
      'number_of_pages',
    ],
  },
};

// Information welche Felder zur Join-Entity von isPartOf/hasPart gehören müssen
// child: {
//  parent: {
//   ...
//  }
// }
export const partRelationData: PartRelationData = {
  fragment: {
    self_contained: {
      pageFirst: true,
      pageLast: true,
      volume: true,
      articleId: true,
      issue: false,
    },
    periodical: {
      pageFirst: true,
      pageLast: true,
      issue: true,
      volume: true,
      articleId: true,
    },
    integrating_resource: {
      issue: true,
      volume: true,
      articleId: true,
      pageFirst: false,
      pageLast: false,
    },
  },
  self_contained_or_fragment: {
    series: {
      volume: true,
      pageFirst: false,
      pageLast: false,
      articleId: false,
      issue: false,
    },
    self_contained: {
      pageFirst: true,
      pageLast: true,
      volume: true,
      articleId: true,
      issue: false,
    },
    integrating_resource: {
      articleId: true,
      pageFirst: false,
      pageLast: false,
      issue: false,
      volume: false,
    },
  },
  self_contained: {
    periodical: {
      volume: true,
      pageFirst: false,
      pageLast: false,
      articleId: false,
      issue: true,
    },
    multi_volume_work: {
      volume: true,
      pageFirst: false,
      pageLast: false,
      articleId: false,
      issue: false,
    },
    series: {
      volume: true,
      pageFirst: false,
      pageLast: false,
      articleId: false,
      issue: true,
    },
  },
  audio_video_object: {
    series: {
      volume: true,
      pageFirst: false,
      pageLast: false,
      articleId: false,
      issue: false,
    },
    integrating_resource: {
      volume: true,
      pageFirst: false,
      pageLast: false,
      articleId: true,
      issue: false,
    },
    periodical: {
      volume: true,
      pageFirst: false,
      pageLast: false,
      articleId: true,
      issue: true,
    },
  },
  thesis: {
    series: {
      volume: true,
      pageFirst: false,
      pageLast: false,
      articleId: false,
      issue: false,
    },
  },
  multi_volume_work: {
    series: {
      volume: true,
      pageFirst: false,
      pageLast: false,
      articleId: false,
      issue: false,
    },
  },
  research_data_group: {
    integrating_resource: {
      volume: true,
      pageFirst: false,
      pageLast: false,
      articleId: true,
      issue: false,
    },
    periodical: {
      volume: true,
      pageFirst: true,
      pageLast: true,
      articleId: true,
      issue: true,
    },
  },
  integrating_resource: {
    research_data_group: {
      volume: true,
      pageFirst: false,
      pageLast: false,
      articleId: true,
      issue: false,
    },
  },
  periodical: {
    research_data_group: {
      pageFirst: true,
      pageLast: true,
      issue: true,
      volume: true,
      articleId: true,
    },
  },
};